import script from "./token-setting.vue?vue&type=script&setup=true&lang=ts"
export * from "./token-setting.vue?vue&type=script&setup=true&lang=ts"

import "./token-setting.vue?vue&type=style&index=0&id=a2858f78&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/K8S-上海阿里云Prod环境-UOTS-Front/frontend/front-uots-simulator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2858f78"]])

export default __exports__